import { render, staticRenderFns } from "./tomeResourceApply.vue?vue&type=template&id=3f01d135&scoped=true&"
import script from "./tomeResourceApply.vue?vue&type=script&lang=js&"
export * from "./tomeResourceApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f01d135",
  null
  
)

export default component.exports